import React from "react";
import { fromDDMMYYYY } from "src/utils/datefns";

const CustomInput = React.forwardRef(({ label, id, value, onClick, keyboardDisabled = false, destinationColors = false, locale = "en" }, ref) => {
  const dayFormatter = new Intl.DateTimeFormat(locale, {
    month: 'long', day: 'numeric', weekday: "short"
  })

  let formattedDate = "";
  if (value) {
    if (isNaN(new Date(value).getTime())) {
      formattedDate = dayFormatter.format(fromDDMMYYYY(value))
    } else {
      formattedDate = dayFormatter.format(new Date(value));
    }
  }
  

  return <div
    ref={ref}
    className="relative"
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.nativeEvent.code === "Space" || e.nativeEvent.code === "Enter")
        onClick();
    }}
    tabIndex={0}
  >
    <input
      type="text"
      id={id}
      className={`${keyboardDisabled ? "pointer-events-none" : ""} md:cursor-pointer block px-2.5 pb-2.5 pt-4 w-full text-base font-semibold text-[#242426] bg-transparent rounded-lg border-1 ${destinationColors ? "border-[color:var(--highlightedSecondaryColor)]" : "border-[#efeff4]"}  appearance-none focus:outline-none focus:ring-0 focus:border-[#3560DA] peer`}
      placeholder=" "
      value={formattedDate}
      readOnly
    />
    <label
      htmlFor={id}
      className={`absolute text-base font-semibold duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] ${destinationColors ? "bg-[color:var(--highlightedPrimaryColor)] text-[color:var(--highlightedSecondaryColor)]" : "bg-white text-[#75757D]"}  px-2 peer-focus:px-2 peer-focus:text-[#3560DA] peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1`}
    >
      {label}
    </label>
  </div>
});

export default CustomInput;
